<template>
  <div>
    <div class="flex flex-row items-center justify-between py-4 px-8">
      <div>
        <p class="page-sub">
          Welcome. Here are the things you can do. You can always find them on
          the sidebar on the left.
        </p>
      </div>
      <div>
        <img
          class="h-24 md:mr-4"
          :src="require('../../assets/tenant_dashboard.png')"
          alt=""
        />
      </div>
    </div>
    <l-dashboard />
    <hr class="my-4 tenant-main-color" />

    <div class="flex flex-wrap mx-6 ">
      <l-dashboard-card
        v-for="(card, i) in cards"
        :key="i"
        :card="card"
        class="w-full lg:w-1/4 md:w-1/3 sm:w-1/2 sm:p-2 p-4"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {
    LDashboardCard: () => import("@/components/tenant/dashboard-card"),
    LDashboard: () => import("@/components/tenant/dashboard"),
  },
  data() {
    return {
      cname: "",
      form: {},
      user: this.$store.state.auth.user,
      error: {},
      search: "",
      cards: [
        {
          title: "Learner Management",
          description: "Manage all your  Learners",
          route: "tenant-users-home",
          image:
            "https://res.cloudinary.com/lms-edc/image/upload/v1594124466/Assets/gj2mfxzt8pzuhdyskz3h.png",
        },
        {
          title: "Program Management",
          description: "Create, edit and manage programs.",
          image:
            "https://res.cloudinary.com/dldd8ucby/image/upload/v1590854501/LMS/program.png",
          route: "tenant-programs",
        },
        {
          title: "Course Management",
          description: "Manage courses, modules, lessons and exercises.",
          image:
            "https://res.cloudinary.com/dldd8ucby/image/upload/v1590854501/LMS/course.png",
          route: "tenant-courses",
        },
        {
          title: "Badges",
          description: "Create and Manage Badges",
          image:
            "https://res.cloudinary.com/lms-edc/image/upload/v1596524347/Assets/vqafvtehso7yqyodknds.png",
          route: "tenant-badges-home",
        },
        {
          title: "Course Coupons",
          description: "View and Manage Course Coupons",
          image:
            "https://res.cloudinary.com/lms-edc/image/upload/v1594517172/Assets/chovh7jpbkgd4ixmc2fn.png",
          route: "tenant-coupon-home",
        },
        {
          title: "To do Lists",
          description: "Create and Manage To Do Lists",
          image:
            "https://res.cloudinary.com/lms-edc/image/upload/v1596524334/Assets/ohhz1fkszmtbphbefou6.png",
          route: "tenant-todo-home",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchAdminRoles", "fetchSingleTenant"]),
  },
  async mounted() {
    let user = await this.fetchSingleTenant({
      id: this.user.id,
    });

    this.cname = user.company_name;
    // //console.log(user)
    // this.fetchAdminRoles();
  },
};
</script>
<style scoped>
.page-header {
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: 0.11px;
}

.page-sub {
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.11px;

  color: #043f6c;
}
</style>
